
export default {
  props: {
    images: {
      type: Array,
      default: () => []
    },
    speed: {
      type: Number,
      default: 50000
    },
    height: {
      type: String,
      default: '120'
    }
  },
  data: function() {
    return {
      rollSpeed: ''
    };
  },
  mounted () {
    setTimeout(() => {
      this.rollSpeed = '--roll-speed:' + this.speed + 'ms;'
    }, 100)
  }
}
